import { render, staticRenderFns } from "./BatchCardActivation.vue?vue&type=template&id=68f4bbb0&scoped=true&"
import script from "./BatchCardActivation.vue?vue&type=script&lang=js&"
export * from "./BatchCardActivation.vue?vue&type=script&lang=js&"
import style0 from "./BatchCardActivation.vue?vue&type=style&index=0&id=68f4bbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4bbb0",
  null
  
)

export default component.exports